import { render, staticRenderFns } from "./MatterSimplifiedDestructionForm.vue?vue&type=template&id=7584362a&"
import script from "./MatterSimplifiedDestructionForm.vue?vue&type=script&lang=js&"
export * from "./MatterSimplifiedDestructionForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterSimplifiedDestructionForm.vue?vue&type=style&index=0&id=7584362a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports